import { call, put, takeLatest } from 'redux-saga/effects';
import Apis from '../../../../../../api';
import MessageActions from '../../../../../message/redux/actions';
import { CommonAction } from '../../../../../message/redux/types';
import TeamManagementActions from './actions';
import TeamManagementTypes from './types';

const fetchTeamMembers = function* fetchTeamMembers(action: CommonAction) {
    try {
        const { data } = yield call(Apis.getTeamMember, action.payload);

        yield put(TeamManagementActions.setTeamMembers(data));
    } catch (err) {
        yield put(TeamManagementActions.failedFetchTeamMembers());
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const addTeamMembers = function* addTeamMembers(action: CommonAction) {
    try {
        const { investorUUID, investorList } = action.payload;
        const inviteEmail = investorList.map((item: string) => ({ email: item, role: 'Member' })) || [];
        const { data } = yield call(Apis.inviteTeamMember, investorUUID, inviteEmail);
        yield put(TeamManagementActions.setTeamMembers(data));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};
export default function* sagas() {
    yield takeLatest(TeamManagementTypes.FETCH_TEAM_MEMBERS, fetchTeamMembers);
    yield takeLatest(TeamManagementTypes.INVITE_TEAM_MEMBERS, addTeamMembers);
}
